export default {
  search: {
    mdm: "Maestro de materiales",
  },
  warning: {
    coincidence: "Usted tiene un material con una coincidencia alta",
    stockcode: "Código de stock",
    continue: "Cerrar",
    see: "Ver Material",
    continuing: "Puede usar un material como plantilla al seleccionar uno de la lista",
  },
  searchTitle: "Buscar",
  useAsTemplate: "Usar como plantilla",
  clearSelection: "Limpiar selección",
  useWithOutATemplate: "Crear material sin plantilla",
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/cataloger/createNewMaterials/CAT4MRO/search.js